
import { Component } from 'react'
import Post from '../../src/components/post'
import ComponentTree from '../../src/components/component-tree'
import components from '../../src/components/md-components'

export default (props) => {
  const data = {
  "title": "whenisgoldenhour; now with https and react",
  "created": "2019-08-10",
  "categories": "[\"dev\", \"golden hour\"]",
  "path": "pages/posts/undefined.js",
  "permalink": "posts/undefined",
  "tags": [
    "dev",
    "golden hour"
  ],
  "draft": false
}
  const body = {"type":"div","props":{},"children":[{"type":"p","props":{},"children":["A couple months back, I spent some time sprucing ",{"type":"a","props":{"href":"https://whenisgoldenhour.com"},"children":["whenisgoldenhour.com"]}," in two ways. The first, was setting up https for the site. Nothing special here; just used AWS ACM for the cert -- and now we have our cool green lock in your browser."]},"\n",{"type":"img","props":{"src":"/static/images/posts/2019-08-10-whenisgoldenhour-updates/screenshot1.png","width":400}},"\n",{"type":"p","props":{},"children":["We're not collecting user submitted information or credit cards on the site, so no relevance there. There ",{"type":"em","props":{},"children":["is"]}," the location data we send/receive between google that could technically have been man-in-the-middled pre-HTTPS -- though those locations don't have a high level of precision. Other than that, there are also SEO benefits to being HTTPS compliant. "]},"\n",{"type":"p","props":{},"children":["The second piece was cleaning up the garbage vanilla javascript the site was originally written in. The result has been a more solid/readable implementation which can be ",{"type":"a","props":{"href":"https://github.com/ksho/whenisgoldenhour.com"},"children":["found on github"]},". For users, the site looks and functions exactly the same as before. Laying this foundation will make it easier to add features going forward."]}]}
  return (
    <Post {...data}>
      <ComponentTree {...body} components={components} />
    </Post>
  )
}
